import { render, staticRenderFns } from "./OrganizationInfoCoverLogo.vue?vue&type=template&id=41511d23"
import script from "./OrganizationInfoCoverLogo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfoCoverLogo.vue?vue&type=script&lang=js"
import style0 from "./OrganizationInfoCoverLogo.vue?vue&type=style&index=0&id=41511d23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports